import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(async () => {
	const selector = `.${manifest.blockJsClass}`;
	const multiselectFilterElement = document.querySelector(selector);
	const placeholder = multiselectFilterElement?.getAttribute('data-placeholder');

	if (!multiselectFilterElement) {
		return;
	}

	const { ProductUpdatesFilter } = await import('./product-updates-filter');
	const MultiSelect = await import('./multi-select');

	// Initialize the product updates filter
	const productUpdatesFilter = new ProductUpdatesFilter(multiselectFilterElement);

	// Initialize the multiselect with our filter callbacks
	const multiselectInstance = new MultiSelect.MultiSelect(multiselectFilterElement, {
		placeholder: placeholder,
		onSelect: function (value, text, element) {
			productUpdatesFilter.onModuleSelect(value, text, element);
		},
		onUnselect: function (value, text, element) {
			productUpdatesFilter.onModuleUnselect(value, text, element);
		},
	});

	// Listen for clear multiselect event from search
	document.addEventListener('clearMultiselectFilter', () => {
		multiselectInstance.clearSelection();
	});
});
